import styled from "styled-components";

export const AppContainer = styled.div`
  font-family: "Lato", Sans-serif;
  font-size: 1em;
`;
